var map = {
	"./en.json": [
		34018,
		"src_app_cws2_0_credit-card_assets_i18n_en_json"
	],
	"./ja.json": [
		70624,
		"src_app_cws2_0_credit-card_assets_i18n_ja_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66684;
module.exports = webpackAsyncContext;